import {createContext, useContext} from "react";

export const AppLayoutContext = createContext<{
  headerHeight?: number;
  setHeaderHeight?: (n?: number) => void;
}>({});
export const useAppLayoutContext = () => {
  return useContext(AppLayoutContext);
};
